/**
 * 推广员佣金管理页面 - 更新至最新政策
 */
import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// 最新佣金配置（2026-07-17 更新）
const COMMISSION_CONFIG = [
  { name: '七彩故事工坊(首年)', price: 298, cost: 5, free: 30, deposit: 40, certified: 50 },
  { name: '七彩故事工坊(续费)', price: 198, cost: 5, free: 30, deposit: 40, certified: 50 },
  { name: 'AI动画2次包', price: 19.9, cost: 2, free: 30, deposit: 40, certified: 50 },
  { name: 'AI动画20次包', price: 99, cost: 10, free: 30, deposit: 40, certified: 50 },
  { name: 'AI动画60次包', price: 259, cost: 25, free: 30, deposit: 40, certified: 50 },
]

export default function PartnerCommissions() {
  const [commissions, setCommissions] = useState([])
  const [partners, setPartners] = useState([])
  const [config, setConfig] = useState([])
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('records')

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    setLoading(true)
    try {
      const configRes = await fetch(`${API}/order-commission/config`)
      const configData = await configRes.json()
      if (configData.success) setConfig(configData.data || [])

      const partnerRes = await fetch(`${API}/partners`)
      const partnerData = await partnerRes.json()
      if (partnerData.success) setPartners(partnerData.data || [])

      const allCommissions = []
      for (const partner of (partnerData.data || []).slice(0, 20)) {
        try {
          const res = await fetch(`${API}/partner-commissions/partner/${partner.id}`)
          const data = await res.json()
          if (data.success && data.data) {
            data.data.forEach(c => {
              allCommissions.push({
                ...c,
                partnerName: partner.name,
                partnerLevel: partner.level,
                statusText: c.status === 'paid' ? '已结算' : '待结算'
              })
            })
          }
        } catch (e) { console.error(e) }
      }
      setCommissions(allCommissions)
    } catch (e) {
      console.error('加载失败', e)
    } finally {
      setLoading(false)
    }
  }

  const stats = {
    total: commissions.length,
    paid: commissions.filter(c => c.status === 'paid').length,
    pending: commissions.filter(c => c.status === 'pending').length,
    totalAmount: commissions.reduce((sum, c) => sum + (c.commission || 0), 0),
    paidAmount: commissions.filter(c => c.status === 'paid').reduce((sum, c) => sum + (c.commission || 0), 0),
    pendingAmount: commissions.filter(c => c.status === 'pending').reduce((sum, c) => sum + (c.commission || 0), 0)
  }

  const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }

  const LEVEL_INFO = {
    free: { label: '免费推广员', color: '#13c2c2' },
    deposit: { label: '保证金推广员', color: '#722ed1' },
    certified: { label: '认证推广员', color: '#fa8c16' },
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>💰 佣金管理</h2>
        <button onClick={loadData} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>🔄 刷新</button>
      </div>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>佣金记录</div><div style={{ fontSize: 24, color: '#1890ff' }}>{stats.total}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>已结算</div><div style={{ fontSize: 24, color: '#52c41a' }}>{stats.paid}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>待结算</div><div style={{ fontSize: 24, color: '#faad14' }}>{stats.pending}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>累计佣金</div><div style={{ fontSize: 24, color: '#f5222d' }}>¥{stats.totalAmount.toFixed(2)}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>已结算金额</div><div style={{ fontSize: 24, color: '#52c41a' }}>¥{stats.paidAmount.toFixed(2)}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>待结算金额</div><div style={{ fontSize: 24, color: '#faad14' }}>¥{stats.pendingAmount.toFixed(2)}</div></div>
      </div>

      {/* 标签页 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[
          { key: 'records', label: '佣金记录' },
          { key: 'config', label: '佣金配置' },
          { key: 'withdraw', label: '提现管理' }
        ].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{ padding: '8px 20px', background: tab === t.key ? '#1890ff' : '#f5f5f5', color: tab === t.key ? '#fff' : '#666', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'records' && (
        <div style={cardStyle}>
          <div style={{ overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={th}>推广员</th>
                  <th style={th}>级别</th>
                  <th style={th}>产品</th>
                  <th style={{ ...th, textAlign: 'right' }}>订单金额</th>
                  <th style={{ ...th, textAlign: 'right' }}>佣金比例</th>
                  <th style={{ ...th, textAlign: 'right' }}>佣金金额</th>
                  <th style={{ ...th, textAlign: 'center' }}>状态</th>
                  <th style={th}>时间</th>
                </tr>
              </thead>
              <tbody>
                {commissions.length === 0 ? (
                  <tr><td colSpan={8} style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无佣金记录</td></tr>
                ) : commissions.map((c, i) => {
                  const levelKey = Object.entries(LEVEL_INFO).find(([,v]) => v.label === c.partnerLevel)?.[0]
                  const levelColor = levelKey ? LEVEL_INFO[levelKey].color : '#13c2c2'
                  return (
                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 12, fontWeight: 500 }}>{c.partnerName || '-'}</td>
                      <td style={{ padding: 12 }}>
                        <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: levelColor, color: '#fff' }}>
                          {c.partnerLevel || '免费推广员'}
                        </span>
                      </td>
                      <td style={{ padding: 12 }}>{c.product_name || '-'}</td>
                      <td style={{ padding: 12, textAlign: 'right' }}>¥{c.amount || 0}</td>
                      <td style={{ padding: 12, textAlign: 'right', color: '#52c41a' }}>{c.commission_rate || 0}%</td>
                      <td style={{ padding: 12, textAlign: 'right', fontWeight: 600, color: '#f5222d' }}>¥{c.commission || 0}</td>
                      <td style={{ padding: 12, textAlign: 'center' }}>
                        <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: c.status === 'paid' ? '#f6ffed' : '#fffbe6', color: c.status === 'paid' ? '#52c41a' : '#faad14' }}>
                          {c.statusText}
                        </span>
                      </td>
                      <td style={{ padding: 12, color: '#999', fontSize: 12 }}>{c.created_at ? new Date(c.created_at).toLocaleDateString() : '-'}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'config' && (
        <div style={cardStyle}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>💡 佣金比例说明（2026-07-17 更新）</h3>
          <div style={{ overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={th}>产品</th>
                  <th style={{ ...th, textAlign: 'right' }}>售价(¥)</th>
                  <th style={{ ...th, textAlign: 'right' }}>成本(¥)</th>
                  <th style={{ ...th, textAlign: 'center', color: '#13c2c2' }}>免费推广员</th>
                  <th style={{ ...th, textAlign: 'center', color: '#722ed1' }}>保证金推广员</th>
                  <th style={{ ...th, textAlign: 'center', color: '#fa8c16' }}>认证推广员</th>
                </tr>
              </thead>
              <tbody>
                {(config.length > 0 ? config : COMMISSION_CONFIG).map((c, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 12, fontWeight: 500 }}>{c.name}</td>
                    <td style={{ padding: 12, textAlign: 'right' }}>¥{c.price}</td>
                    <td style={{ padding: 12, textAlign: 'right', color: '#999' }}>¥{c.cost}</td>
                    <td style={{ padding: 12, textAlign: 'center', color: '#13c2c2' }}>{c.free || c.personal || 30}%</td>
                    <td style={{ padding: 12, textAlign: 'center', color: '#722ed1' }}>{c.deposit || c.certified || 40}%</td>
                    <td style={{ padding: 12, textAlign: 'center', color: '#fa8c16' }}>{c.certified || c.agency || 50}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 16, padding: 12, background: '#f6ffed', borderRadius: 8, fontSize: 13 }}>
            <div style={{ fontWeight: 600, color: '#52c41a', marginBottom: 8 }}>💡 计算公式</div>
            <div style={{ color: '#666', lineHeight: 1.8 }}>
              佣金金额 = 订单金额 × 佣金比例<br/>
              总部利润 = 订单金额 - 产品成本 - 佣金金额<br/>
              管理奖 = 下级佣金 × 20%（二级到头，不再往下分）
            </div>
          </div>
        </div>
      )}

      {tab === 'withdraw' && (
        <div style={cardStyle}>
          <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>💸</div>
            <div style={{ fontSize: 16, marginBottom: 8 }}>提现功能开发中</div>
            <div style={{ fontSize: 13 }}>推广员可在推广中心申请提现，管理员审核后打款</div>
          </div>
        </div>
      )}
    </div>
  )
}

const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
